var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 56 11 C 48.8 11 43 16.8 43 24 C 43 25.7 44.3 27 46 27 C 47.7 27 49 25.7 49 24 C 49 20.1 52.1 17 56 17 L 72 17 C 75.9 17 79 20.1 79 24 C 79 25.7 80.3 27 82 27 C 83.7 27 85 25.7 85 24 C 85 16.8 79.2 11 72 11 L 56 11 z M 24 31 C 16.8 31 11 36.8 11 44 L 11 61 C 11 62.1 11.6 62.999609 12.5 63.599609 C 28.4 73.099609 46.2 77.900391 64 77.900391 C 81.8 77.900391 99.6 73.099609 115.5 63.599609 C 116.4 62.999609 117 62.1 117 61 L 117 44 C 117 36.8 111.2 31 104 31 L 24 31 z M 24 37 L 104 37 C 107.9 37 111 40.1 111 44 L 111 59.300781 C 81.9 76.100781 46.1 76.100781 17 59.300781 L 17 44 C 17 40.1 20.1 37 24 37 z M 14 73 C 12.3 73 11 74.3 11 76 L 11 104 C 11 111.2 16.8 117 24 117 L 104 117 C 111.2 117 117 111.2 117 104 L 117 76 C 117 74.3 115.7 73 114 73 C 112.3 73 111 74.3 111 76 L 111 104 C 111 107.9 107.9 111 104 111 L 24 111 C 20.1 111 17 107.9 17 104 L 17 76 C 17 74.3 15.7 73 14 73 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.202f048f959df7b533b3dca1dcad6b9b.svg";
export { ForwardRef as ReactComponent };